import CustomersTable from "@/components/customers/CustomersTable";

export default function CustomersPage() {
  return (
    <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 space-y-8">
      <CustomersTable />
    </div>
  );
}
